<template>
  <div v-if="thread.comments_count > 0" class="all-comments">
    <div class="comment-wrapper">
      <div class="comments__total-count">
        {{ thread.comments_count }}
        <span v-if="thread.comments_count === 1">Comment</span>
        <span v-if="thread.comments_count > 1">Comments</span>
      </div>
      <div
        v-for="comment in thread.comments"
        :key="comment.id"
        class="comments"
      >
        <div class="comments__comment">
          <CommentComponent :comment="comment" @replyShow="showReply" />
        </div>

        <div
          v-for="reply in comment.replies"
          :key="reply.id"
          class="comments__reply"
        >
          <CommentComponent :comment="reply" @replyShow="showReply" />
        </div>

        <div v-if="isShowReply(comment)" class="comments__reply">
          <CommentReply
            :doc="doc"
            :thread="thread"
            :comment="comment"
            @replyPosted="hideReply"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import CommentComponent from '@/app/components/community/Comment.vue'
import CommentReply from '@/app/components/community/CommentReply.vue'

import { Comment } from '@/models/interfaces'
import { DocView } from '@/models/doc'
import { ThreadView } from '@/models/forum'

defineProps<{
  doc: DocView
  thread: ThreadView
}>()

const replyComment = ref<Comment | null>(null)

function isShowReply(comment: Comment): boolean {
  return !!replyComment.value && replyComment.value === comment
}

function showReply(comment: Comment): void {
  replyComment.value = comment
}

function hideReply(): void {
  replyComment.value = null
}
</script>
